module.exports = __webpack_public_path__ + "img/perfectionwax.c102e6b8.jpg";